import {combineReducers} from 'redux';
import LearningroomReducer from './LearningroomReducer';
import ActionGoalReducer from './ActionGoalReducer';
import NewpostReducer from './NewpostReducer';
import InboxReducer from './InboxReducer';
import ProfileReducer from './ProfileReducer';

const allReducers = combineReducers({
    learningRoom: LearningroomReducer,
    actionGoal:ActionGoalReducer,
    newPost:NewpostReducer,
    inbox:InboxReducer,
    profile:ProfileReducer,
});
export default allReducers


// WEBPACK FOOTER //
// ./src/reducers/index.js